<template>
    <div
    class="offcanvas offcanvas-end"
        tabindex="-1"
        id="offcanvasLampiran"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                Lampiran ACARA SARANA
            </h5>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                <form
                    @submit.prevent="updateLampiran"
                    autocomplete="off"
                    autocapitalize="on"
                    enctype="multipart/form-data"
                >
                    
                    <div class="mb-3">
                        <label class="form-label" for="lampiranBA">Lampiran Berita Acara</label>
                        <input
                            type="file"
                            class="form-control"
                            id="lampiranBA"
                            ref="filesRef"
                            name="lampiranBA[]"
                            placeholder="Lampiran Berita Acara"
                            required="required"
                            @change="handleFileObject"
                        />
                    </div>
                    <button
                        class="btn btn-primary me-3 data-submit"
                    >
                        Submit
                    </button>
                    <button
                        id="dismisBtn"
                        type="reset" 
                        class="btn btn-outline-danger"
                        data-bs-dismiss="offcanvas"
                    >
                        Cancel
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { ref } from "vue";
import { uid } from 'uid';
const filesRef = ref(null);
import moment from "moment";
export default {
    mounted() {
    },
    data() {
        return {
            moment:moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            users:{},
            fName:uid(),
            lampiran:'',
            filenames:'',
            dtime:new Date()
        };
    },
    props: ["tokens", "url_action","username"],
    methods: {
        updateLampiran(e) {
            this.fName = uid()
            let currentObj = this;
            var fData = new FormData()
            fData.append('file', this.lampiran)
            fData.append('title', this.fName)
            
            let config = {
                            headers: { 'content-type': 'multipart/form-data' }
                            }
            axios
                .post("/sarana/ba",fData,config)
                .then(function (response) {
                console.log(response.data)
                    var d = response.data
                    currentObj.success = d.success
                    currentObj.filenames = d.filename
                    currentObj.sendEmit()
                    $("#dismisBtn").click();
                })
                .catch(function (error) {
                    currentObj.output = error;
                });
        },
        handleFileObject(e) {
            this.lampiran = e.target.files[0]
            this.sendEmit()
      },
        sendEmit(){
            this.$emit("beritaAcaraEmit",this.filenames);
        }

    },
    expose: ["fName"],
};
</script>